import {Partner} from '@soluto-private/mx-context-types';
import {createProvider, Provider} from '@soluto-private/mx-config';
import {monitor} from '@soluto-private/mx-monitor';

const canUseDefaultProductType = async (partner: Partner) => {
    const provider = createProvider(Provider.OneServiceApi);

    try {
        const configuration = await provider.getMxConfiguration(partner);
        return !!configuration;
    } catch (error) {
        monitor.error('Error fetching configuration', error, {partner});
        return false;
    }
};

export default canUseDefaultProductType;
